import { FormControlLabel, styled, Typography } from "@mui/material";
import { isPropValid } from "web_myplann/Infrastructure/Utils/StyleUtils";

export const StyledFormControl = styled("div")<{
	$vertical?: boolean;
	$fullWidth?: boolean;
	$alignLabel?: "start" | "center" | "end";
	$gap?: number;
}>`
	display: ${(props) => (props.$vertical ? "block" : "flex")};
	justify-content: start;
	align-items: ${(props) => props.$alignLabel ?? "center"};
	flex-direction: row;
	gap: ${(props) => props.$gap ?? 16}px;
	min-width: 0;
	position: relative;
	${(props) => props.$fullWidth && "width: 100%;"}

	&.long {
		flex: 0 0 360px;
		max-width: 360px;
	}

	&.medium {
		flex: 0 0 235px;
		max-width: 235px;
	}

	&.tiny {
		flex: 0 0 85px;
		max-width: 85px;
	}

	&.no-label:not(.filter):not(.no-padding) {
		padding-top: 0px;
	}

	&.no-label {
		.MuiFormControl-root {
			margin-top: 0;
		}

		.bl-text-input__unit {
			top: 0;
		}
	}
`;

export const StyledFormLabelWrapper = styled("div")<{
	$disabled: boolean;
	$vertical?: boolean;
	$fontWeight?: string;
	$fullWidth?: boolean;
	$labelWidth?: string;
}>`
	display: flex;
	align-items: center;
	z-index: 1;
	font-size: 12px;
	font-weight: 400;
	flex-shrink: 0;

	label {
    width: ${(props) => (props.$fullWidth ? "100%" : (props.$labelWidth ?? ""))};
		display: flex;
		align-items: center;
		margin: 0;
		padding-bottom: ${(props) => (props.$vertical ? "1rem" : 0)};
		color: ${(props) =>
			props.$disabled
				? props.theme.palette.text.disabled
				: props.theme.palette.text.primary};
		p {
			font-weight: ${(props) => props.$fontWeight ?? undefined};
      line-height: 1.1;
		}
	}
`;

export const StyledFormInput = styled("div")`
	flex-grow: 1;
	min-width: 0;

	& > div {
		display: flex;
	}
`;

export const StyledValidationText = styled(Typography, {
	shouldForwardProp: isPropValid,
})<{
	$hasFilterStyle?: boolean;
	$fontSize?: string;
}>`
	font-size: ${(props) => props.$fontSize ?? "12px"};
	color: ${(props) => props.theme.palette.error.main};
	min-height: ${(props) => (props.$hasFilterStyle ? "0px" : "16.6px")};
  line-height: 16.5px;
`;

export const StyledFormControlLabel = styled(FormControlLabel)<{
	minWidth?: string;
	width?: string;
}>`
  display: flex;
  flex-flow: row;
  align-items: center;
  margin-left: 0;
  margin-right: ${(props) => (props.minWidth ? 0 : props.theme.spacing(5))};
  min-width: ${(props) => props.minWidth ?? undefined};
  width: ${(props) => props.width ?? undefined};

  .MuiCheckbox-root {
    padding: 9px 9px 9px 0;
  }

  .Mui-checked + span p:first-of-type {
    font-weight: 600;
  }
`;
